/**
 * Home 画面用 JS
 * 参照: .cursor/skills/create-feature/references/04-ui-design/content.js の Home クラスを抽出
 */
class Home {
    constructor() {
        this.rTimer = false; // スライダー再生時間
        this.isFirst = true; // 初回表示フラグ
    }

    init() {
        // スライダー初期化
        this.initMv();
        this.runIntro();
    }

    /**
     * MV（メインビジュアル）スライダー初期化
     * #slider01 に SimpleSlider を適用
     */
    initMv() {
        if (typeof azlib === 'undefined' || !document.querySelector('#slider01')) {
            return;
        }
        const slider01 = new azlib.SimpleSlider('#slider01', {
            speed: 500,
            pause: 4000,
            isAuto: true,
            spaceBetween: 40,
            prevEl: '#js-prev01',
            nextEl: '#js-next01',
            pagerEl: '#js-pager01',
            isStopOnHover: false,
        });
    }

    /**
     * イントロ表示（wrapper の表示制御）
     */
    runIntro() {
        const wrapper = document.getElementById('wrapper');
        if (!wrapper) {
            return;
        }
        this.isFirst = false;
        Object.assign(wrapper.style, {
            visibility: 'visible',
            opacity: 0,
        });
    }
}

/**
 * Home 画面でのみ初期化を実行
 */
document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('home')) {
        const home = new Home();
        home.init();
    }
});
